import { useMemo } from 'react';
import { useDateTimeText } from '../../hook/useDateTimeText';
import { useRepairDetailStatusInfo } from '../../hook/useRepairDetailStatusInfo';
import { FilledButton, OutlinedButton } from '../../util/button';
import { FactoryInfoCard } from '../../util/common/factoryInfoCard';
import { RepairDetailStatusInfoType } from '@/types/bodyAndPaint';

interface RepairProgressStatusProps {
  info: RepairDetailStatusInfoType;
  checkRepairImage: () => void;
  pickUpReserve: () => void;
}
export const RepairProgressStatusField = ({
  info,
  checkRepairImage,
  pickUpReserve,
}: RepairProgressStatusProps) => {
  const { status, checkInDate, pickUpDate, factoryInfo } = useMemo(() => {
    return {
      status: info?.status ?? -1,
      checkInDate: info?.check_in_date ?? undefined,
      pickUpDate: info?.pick_up_date ?? undefined,
      factoryInfo: {
        factoryName: info?.factory_name ?? '',
        telephone: info?.factory_telephone ?? '',
        address: info?.factory_gps_info ?? '',
      },
    };
  }, [info]);

  const { currentState, statusClass, headerText, bodyText } =
    useRepairDetailStatusInfo({ status, pickUpDate });

  const checkInDateItem = useDateTimeText({
    dateTime: checkInDate,
  });

  const pickUpDateItem = useDateTimeText({
    dateTime: pickUpDate,
  });

  const handleClickCheckRepairImage = () => checkRepairImage();
  const handleClickPickUpReserve = () => pickUpReserve();

  const ScheduleDateField = () => {
    const ScheduleDateItem = ({
      label,
      dateText,
    }: {
      label: string;
      dateText: string;
    }) => {
      return (
        <div className={'schedule-date-field'}>
          <div className={'schedule-tag-label'}>
            <span>{label}</span>
          </div>
          <div className={'schedule-info-date'}>
            <span>{dateText}</span>
          </div>
        </div>
      );
    };
    switch (currentState) {
      case 'CHECK_IN_ACCEPTED':
      case 'CHECK_IN_COMPLETED':
        return (
          <ScheduleDateItem label={'入庫日'} dateText={checkInDateItem ?? ''} />
        );
      case 'REPAIR_EXECUTING':
      case 'REPAIR_HAS_DONE':
      case 'DELIVERED_HAS_DONE':
      case 'PICK_UP_PRE_CONFIRMED':
        return (
          <OutlinedButton
            label={'修理箇所の画像を確認'}
            onClick={handleClickCheckRepairImage}
          />
        );
      case 'PICK_UP_CONFIRMED':
        return (
          <ScheduleDateItem label={'返却日'} dateText={pickUpDateItem ?? ''} />
        );
      default:
        return <></>;
    }
  };

  return (
    <div className={'repair-progress-status-info'}>
      <div className={`repair-status-icon ${statusClass}`}>
        <i className={'icon'} />
      </div>
      <div className={`repair-status-message`}>
        <div className={`message-header`}>
          <span>{headerText}</span>
        </div>
        <div className={`message-body`}>
          {(bodyText ?? ['']).map((text, idx) => (
            <span key={idx}>{text}</span>
          ))}
        </div>
      </div>
      <ScheduleDateField />
      <FactoryInfoCard
        factoryName={factoryInfo.factoryName}
        telephone={factoryInfo.telephone}
        address={factoryInfo.address}
      />
      {currentState === 'REPAIR_HAS_DONE' && (
        <div className={'button-field reserve-pick-up'}>
          <FilledButton
            onClick={handleClickPickUpReserve}
            label={'返却日を予約する'}
          />
        </div>
      )}
    </div>
  );
};
